import SavedSearchesList from './SavedSearchesList'

export default SavedSearchesList
